import { SnackbarProps, SnackbarStatus } from '@weareopenr/component-library';
import { boldMenuName } from 'src/helpers/truncateMenuName/boldMenuName';

export const errorNotificationChannelVenues = {
  status: SnackbarStatus.ERROR,
  message: 'Something went wrong fetching Channels and Venues',
} as const;

export const noChannelsSelectedNotification = {
  status: SnackbarStatus.ERROR,
  message: 'You must select at least one channel and venue to publish this menu',
} as const;

export const successNotification = (menuName: string, channelNames: string[], scheduleTime: string): SnackbarProps => ({
  status: SnackbarStatus.SUCCESS,
  message: (
    <>
      You have successfully {scheduleTime ? 'scheduled' : 'published'} {boldMenuName(menuName)} to{' '}
      {channelNames.join(', ')}
    </>
  ),
});

export const errorNotification = (menuName: string, scheduleTime: string, error?: string): SnackbarProps => ({
  status: SnackbarStatus.ERROR,
  message: error || (
    <>
      Something went wrong whilst {scheduleTime ? 'scheduling' : 'publishing'} {boldMenuName(menuName)}
    </>
  ),
});
